import { render } from "./DesktopView.vue?vue&type=template&id=be1c33f2&scoped=true"
import script from "./DesktopView.vue?vue&type=script&lang=js"
export * from "./DesktopView.vue?vue&type=script&lang=js"

import "./DesktopView.vue?vue&type=style&index=0&id=be1c33f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be1c33f2"]])

export default __exports__